import { getRequestCookies, getCookie, api, config, removeCookie } from "helpers"

export async function getUser(lang, state, ctx) {
    const accessToken = getRequestCookies(ctx, 'accessToken') || getCookie('accessToken')
    const newState = state;
    let currentUser;

    if (accessToken) {
        currentUser = await getInfo(lang, accessToken, ctx.res)
    }

    if (!currentUser) {
        newState.isLoggedIn = false
        newState.user = {}
        newState.currentUser = {}
    } else {
        newState.isLoggedIn = true
        newState.user = currentUser
        newState.currentUser = currentUser
    }


    return { newState }
}

const getInfo = async (lang, accessToken) => {
    return await api.get(`${config.routePrefix.users}/me`, {}, accessToken)
        .then(res => {
            return res
        })
        .catch(err => {
            if (process?.browser) {
                document.cookie = 'accessToken=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
            } else {
                removeCookie('accessToken')
            }
        })
}